import { createSelector } from 'reselect';
export const selectGates = state => state.auth.gates;
export const selectUserInformation = state => state.auth.user;
export const selectUserScopes = createSelector([selectUserInformation], user => {
  return user ? user.scopes : [];
});
export const getHasCopilotAccessScope = createSelector([selectUserScopes], scopes => {
  return scopes.includes('chatspot-access');
});
export const selectPortal = state => state.auth.portal;
export const getHasJitaScope = createSelector([selectUserScopes], scopes => {
  return scopes.includes('jita-user');
});